/**
 * Which of the three nav sections a path belongs to.
 *
 * ⚠️ Extracted from the nav component because it decides whether the
 * leave-warning fires, and both ways of getting it wrong are bad: too broad and
 * a customer is warned about ending a session they are not leaving, too narrow
 * and a tap silently clears their photo and every generated image.
 *
 * `/capture` maps to try-on rather than to its own section — it is the gate into
 * try-on and the retake step within it, so navigating there is never "leaving".
 */
export const SECTIONS = ['/', '/try-on', '/admin'] as const;
export type Section = (typeof SECTIONS)[number];

export function sectionOf(pathname: string): Section {
  if (pathname.startsWith('/admin')) return '/admin';
  if (pathname.startsWith('/try-on') || pathname.startsWith('/capture')) return '/try-on';
  return '/';
}

/**
 * Whether moving from `pathname` to `to` abandons a live try-on visit.
 *
 * `hasVisit` is the caller's — a photo exists — because a session with no photo
 * has nothing to lose and must not interrupt anyone.
 */
export function leavesTryOn(pathname: string, to: string, hasVisit: boolean): boolean {
  return hasVisit && sectionOf(pathname) === '/try-on' && sectionOf(to) !== '/try-on';
}
